import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { ProfileEdit } from 'advenio-components'

const CompanyProfileForm = ({ company, company_id, users, centers, update }) => (
  <ProfileEdit
    titleItem={'company'}
    result={company}
    statePath={'companies'}
    typePrefix={'COMPANIES'}
    toUpdateId={company_id}
    rows={[
      {
        fields: [
          {
            name: 'name',
            label: 'Nombre',
            path: 'name',
            type: 'input',
            required: true,
            validations: 'maxLength:255',
            colMd: 6,
          },
          {
            name: 'requires_invoices',
            label: 'Requiere Facturas',
            path: 'requires_invoices',
            type: 'checkbox',
            large: true,
            invertedColors: true,
            inputAlign: true,
            colMd: 3,
          },
          {
            name: 'with_retention',
            label: 'Requiere Retención de IVA',
            path: 'with_retention',
            type: 'checkbox',
            large: true,
            invertedColors: true,
            inputAlign: true,
            colMd: 3,
          },
          {
            name: 'attend_for',
            label: '¿Quién lo Atiende?',
            path: 'attend_for',
            type: 'select',
            options: users,
            optionsValue: 'id',
            optionsLabel: 'name',
            colMd: 6,
            colSd: 6,
          },
          {
            name: 'center_ids',
            label: 'Centros al que aplica esta compañía',
            path: 'centers',
            type: 'tags',
            options: centers,
            optionsValue: 'id',
            optionsLabel: 'name',
            colMd: 12,
          },
        ],
      },
    ]}
  />
)

CompanyProfileForm.propTypes = {
  company_id: PropTypes.string.isRequired,
  company: PropTypes.object.isRequired,
}

CompanyProfileForm.defaultProps = {
}

const mapStateToProps = ({ companies, users, centers }) => ({
  company: companies.getOne.result,
  users: users.get.results,
  centers: centers.get.results,
  update: companies.upgrade.error,
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(CompanyProfileForm)



// WEBPACK FOOTER //
// ./src/Containers/CompanyProfileForm/CompanyProfileForm.jsx